module.exports = __webpack_public_path__ + "54cf98f5/img/settings-icon.121d9519.svg";